<template>
    <rkm-area
        title="Atendimento"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeMensagemAtendimentoRetroativoNaoFinalizado">
                    Exibe mensagem de atendimento retroativo não finalizado
                </rkm-form-checkbox>
            </rkm-col>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeBoxExameLaboratorialSolicitado">
                    Exibe exames laboratoriais predefinidos
                </rkm-form-checkbox>
            </rkm-col>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.receitaNaoPadronizadaJustificativaObrigatoria">
                    Obriga justificativa para receita não padronizada
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
}
</script>